import React, { useState } from 'react'
import moment from 'moment'
import { TableRow, TableCell, Box, Typography, Button } from '@mui/material'
import ClaimReviewSelect from './ClaimReviewSelect'
import styled from 'styled-components'
import { DisplayImageDialog } from '../shared/component/DisplayImageDialog'

const StyledButton = styled(Button)`
  && {
    color: #0c479d;
    text-decoration: underline;
    :hover {
      color: #000;
    }
  }
`

export const ClaimReviewRow = (props) => {
  const { row } = props

  const { staffBenefit } = row

  const renderProcessBy = () => {
    if (row.reviewer) {
      if (row.reviewer?.firstName) {
        return (
          <>
            <Box style={{ fontWeight: 'bold' }}>{row.reviewer?.firstName}</Box>
            <Box>at {moment(row.updatedAt).format('h:mm a, DD/MM/YYYY')}</Box>
          </>
        )
      } else {
        return (
          <>
            <Box style={{ fontWeight: 'bold' }}>{row.reviewer?.email}</Box>
            <Box>at {moment(row.updatedAt).format('h:mm a, DD/MM/YYYY')}</Box>
          </>
        )
      }
    } else {
      return null
    }
  }

  //handle close display image dialog
  const [open, setOpen] = useState(false)
  const handleClose = () => {
    setOpen(false)
  }

  const handleDialog = () => {
    setOpen(!open)
  }

  const uploadPath = row?.invoiceImg?.uploadPath

  return (
    <React.Fragment>
      <TableRow>
        <TableCell align='left'>
          {row.htgCompany}
          {row.processedId}
        </TableCell>
        <TableCell align='left'>{row.user.email ?? row.user?.name}</TableCell>
        <TableCell align='left'>{staffBenefit.staffBenefitCode}</TableCell>
        <TableCell align='left'>{staffBenefit.name}</TableCell>
        <TableCell align='left'>{row.regionalState}</TableCell>
        <TableCell align='left'>{row.quantity}</TableCell>
        <TableCell align='left'>{row.carPlate}</TableCell>
        <TableCell align='left'>{row.carModel}</TableCell>
        <TableCell align='left'>{row.supplier}</TableCell>
        <TableCell align='right'>
          {row.invoiceImg && (
            <StyledButton onClick={handleDialog} size='small'>
              show image
            </StyledButton>
          )}
        </TableCell>
        <TableCell align='left'>{moment(row.createdAt).format('h:mm a, DD/MM/YYYY')}</TableCell>
        <TableCell align='left'>{renderProcessBy()}</TableCell>
        <TableCell align='right'>
          {row.isCompleted ? (
            <Typography style={{ fontWeight: 'bold' }}>{row.status}</Typography>
          ) : (
            <ClaimReviewSelect row={row} />
          )}
        </TableCell>
      </TableRow>
      <DisplayImageDialog handleClose={handleClose} open={open} uploadPath={uploadPath} />
    </React.Fragment>
  )
}
